// navigationSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  currentPage: 'home', 
  isLoading: false,
};

export const navigationSlice = createSlice({
  name: "navigation",
  initialState,
  reducers: {
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setLoaderVisible: (state, action) => {
      state.isLoading = action.payload;
    },

  },
});

export const { setCurrentPage, setLoaderVisible } = navigationSlice.actions;